<div [class.public-pages-bg]="isPublicPage" *ngIf="domainsService.hasDefinedDomain()">
	<router-outlet></router-outlet>
	<div class="cookie-banner" *ngIf="showBanner">
		<div class="cookie-card text-center shadow">
			<h4 class="fw-bold pt-4 pb-3">{{'cookie_policy.cookies' | translate}}</h4>
			<p class="mb-3">{{'cookie_policy.msg0' | translate}}</p>

			<div class="d-flex justify-content-between">
				<button class="btn policy-btn flex-fill ms-2">
					<a class="btn flex-fill" href="/cookie-policy" target="_blank">
						{{ 'cookie_policy.cookie_policy' | translate }}
					</a>
				</button>
				<button class="btn btn-dark flex-fill ms-2" (click)="closeBanner()">
					{{"g.ok"| translate}}
				</button>
			</div>
		</div>
	</div>
</div>
